import { useEffect } from "react";
import mapboxgl from "mapbox-gl";

export const useMapNavigation = ({
    mapInstance,
    selectedEstablishmentId,
    points,
}) => {
    // Effect para mover el mapa al marcador seleccionado
    useEffect(() => {
        if (!mapInstance || !selectedEstablishmentId) return;

        const selectedPoint = points.find(
            (point) => point.id === selectedEstablishmentId
        );
        if (selectedPoint) {
            mapInstance.flyTo({
                center: [selectedPoint.longitude, selectedPoint.latitude],
                zoom: 17,
            });
        }
    }, [selectedEstablishmentId, points, mapInstance]);

    return {
        navigateToPoint: (pointId, zoomLevel = 17) => {
            if (!mapInstance) return;

            const targetPoint = points.find((point) => point.id === pointId);
            if (targetPoint) {
                mapInstance.flyTo({
                    center: [targetPoint.longitude, targetPoint.latitude],
                    zoom: zoomLevel,
                });
            }
        },

        returnToInitialView: (initialCenter, initialZoom) => {
            if (!mapInstance) return;

            if (initialCenter && initialZoom) {
                mapInstance.flyTo({
                    center: initialCenter,
                    zoom: initialZoom,
                    duration: 900,
                });
            }
        },

        fitToAllPoints: () => {
            if (!mapInstance || points.length === 0) return;

            const bounds = new mapboxgl.LngLatBounds();
            points.forEach((point) => {
                bounds.extend([point.longitude, point.latitude]);
            });

            mapInstance.fitBounds(bounds, {
                padding: { top: 100, bottom: 100, left: 100, right: 100 },
                maxZoom: 12,
            });
        },
    };
};
